<script>
import Utils from "@/services/utils";
import SfrLogoSvg from "./brand-logos/SfrLogoSvg.vue";
import BeepizLogoSvg from "./brand-logos/BeepizLogoSvg.vue";
import CatsafeLogoSvg from "./brand-logos/CatsafeLogoSvg.vue";

export default {
  name: "BrandLogoWide",
  components: { SfrLogoSvg, BeepizLogoSvg, CatsafeLogoSvg },
  props: {
    width: {
      type: Number,
      required: false,
      default: undefined
    },
    height: {
      type: Number,
      required: false,
      default: undefined
    },
    isDark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isThemeSfr: Utils.isThemeSfr(),
      isThemeCatsafe: Utils.isThemeCatsafe()
    };
  },
};
</script>
<template>
  <span>
    <SfrLogoSvg v-if="isThemeSfr" :height="height" :width="width" :isDark="isDark" />
    <CatsafeLogoSvg v-else-if="isThemeCatsafe" :height="height" :width="width" :isDark="isDark" />
    <BeepizLogoSvg v-else :height="height" :width="width" :isDark="isDark" />
  </span>
</template>
